module.exports = __webpack_public_path__ + "static/media/cover-date.4ab9f9fc.png";